export default (value) => {
  const longdate = new Date(value)
  return longdate.toLocaleDateString(['en-US'], {month: 'long', day: '2-digit', year: 'numeric'})
}
